import { Pipe, PipeTransform } from '@angular/core';
import { UserService } from '../services/user.service';
import { first, isEmpty } from 'lodash';

@Pipe({
    name: 'sakpUser'
})
export class SakpUserPipe implements PipeTransform {

    constructor(private userService: UserService) { }

    transform(idKeycloak: string, attribute?: 'username' | 'email' | 'avatar'): string {
        if (idKeycloak === '00000000-0000-0000-0000-000000000000')
            return 'SYSTEM';
        const user = this.userService.getByIdKeycloak(idKeycloak);
        if (user == null)
            return idKeycloak;
        if (attribute === 'avatar') {
            if (!isEmpty(user.firstName) && !isEmpty(user.lastName))
                return first(user.firstName) + first(user.lastName);
            else
                return user.username;
        } else
            return attribute != null ? user[attribute] : user.username;
    }

}
